<template>
    <div class="steps__step">
        <div class="steps__step-number"><slot name="number" /></div>
        <div class="steps__step-info">
            <h3 class="steps__step-title"><slot name="title" /></h3>
            <div class="steps__step-description">
                <slot name="description" />
            </div>
        </div>
        <div class="steps__image-container">
            <slot name="image" />
        </div>
    </div>
</template>

<script>
  export default {
    name: "step"
  }
</script>

<style lang="scss" scoped>
    @import '../assets/vars';

    .steps {
        &__step {
            display: flex;
            margin-bottom: 80px;
            box-shadow: 5px 9px 25px 0 rgba(0,0,0,0.25);
            border-radius: 15px;
            position: relative;

            &:last-child {
                margin-bottom: 0;
            }
        }

        &__step-number {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 32px;
            font-weight: 900;
            width: 60px;
            height: 60px;
            box-shadow: 5px 9px 25px 0 rgba(0,0,0,0.25);
            color: white;
            padding: 4px;
            text-align: center;
            background: $color-primary;
            position: absolute;
            top: -30px;
            left: -30px;
            border-radius: 30px;
        }

        &__step-info {
            display: flex;
            flex-direction: column;
            width: 60%;
            padding: 40px 60px;
        }

        &__step-title {
            font-size: 28px;
            font-weight: 900;
            margin-bottom: 18px;
        }

        &__step-description {
            font-size: 18px;
            font-weight: 400;
            line-height: 28px;
            text-align: left;
        }

        &__image-container {
            width: 40%;

            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
                border-top-right-radius: 15px;
                border-bottom-right-radius: 15px;
            }
        }
    }

    /* Landscape phones and portrait tablets */
    @media (max-width: 1023px) {
        .steps {
            &__step {
                flex-direction: column;
                margin-bottom: 40px;
            }

            &__step-info {
                padding: 20px 30px;
                order: 2;
                width: 100%;
            }

            &__image-container {
                order: 1;
                width: 100%;

                img {
                    border-top-left-radius: 15px;
                    border-top-right-radius: 15px;
                    border-bottom-right-radius: 0;
                }
            }

            &__step-number {
                font-size: 20px;
                line-height: 20px;
                font-weight: 900;
                width: 40px;
                height: 40px;
                top: -15px;
                left: unset;
                right: -15px;
            }

            &__step-title {
                font-size: 20px;
            }

            &__step-description {
                font-size: 16px;
            }
        }
    }
</style>